import React, { useState,useRef } from 'react';
import './Contact.css'; // Stil dosyasını import edin

import emailjs from '@emailjs/browser';

const Contact = () => {
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackMessageType, setFeedbackMessageType] = useState('');
  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    const formEl = form.current;
    const first = formEl.querySelector('#firstName')?.value?.trim() ?? '';
    const last = formEl.querySelector('#surname')?.value?.trim() ?? '';
    const nameField = formEl.querySelector('input[name="name"]');
    const timeField = formEl.querySelector('input[name="time"]');
    if (nameField) nameField.value = [first, last].filter(Boolean).join(' ');
    if (timeField) {
      timeField.value = new Date().toLocaleString('tr-TR', {
        dateStyle: 'medium',
        timeStyle: 'short',
      });
    }

    emailjs
      .sendForm('service_40fs2vg', 'template_3k4ncx9', formEl, {
        publicKey: 'SbWNNS0aJaoBIreVU',
      })
      .then(
        () => {
          setFeedbackMessage('Your message has been sent successfully!');
          setFeedbackMessageType('success');
          formEl?.reset();
        },
      (error) => {
        console.error('EmailJS failed:', error.text || error);
        setFeedbackMessage('Failed to send the message. Please try again later.');
        setFeedbackMessageType('error');
      },
    );
  };
  

  return (
    <div className="contact-container"> 
    <div className="contact-image"></div> 
     <form onSubmit={handleSubmit} className="contact-form" ref={form}>
        <input type="hidden" name="name" />
        <input type="hidden" name="time" />

  <div className="input-row">
    <div className="input-group">
      <input
        type="text"
        id="firstName"
        placeholder="name"
        autoComplete="given-name"
        required
      />
    </div>
    <div className="input-group">
      <input
        type="text"
        id="surname"
        placeholder="surname"
        autoComplete="family-name"
        required
      />
    </div>
  </div>
  <div className="input-row">
    <div className="input-group">
      <input
        type="text"
        id="subject"
        placeholder="title"
        name="title"
        required
      />
    </div>
    <div className="input-group">
      <input
        type="email"
        id="email"
        name="user_email"
        placeholder="e-mail"
        required
      />
    </div>
  </div>
  <div>
    <textarea
      id="message"
      required
      name="message"
      placeholder="text here"
    ></textarea>
  </div>
  <button type="submit" value="Send">SEND</button>
</form>
{feedbackMessage && (
        <div className={`feedback-message ${feedbackMessageType}`}>
          {feedbackMessage}
        </div>
      )}
    </div>
  );
};

export default Contact;